import { Component } from "react";

// Shows the real error instead of a blank screen (helps diagnose phone-only issues).
export default class GateErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="p-4 border-2 border-[#b91c1c] bg-[#fef2f2] space-y-3" data-testid="gate-error-boundary">
        <div className="font-bold text-[#b91c1c]">Something went wrong on this screen</div>
        <div className="text-xs font-mono break-words">{String(this.state.error?.message || this.state.error)}</div>
        <button type="button" onClick={() => window.location.reload()} data-testid="gate-error-reload"
          className="w-full py-3 bg-ink text-white font-bold">Reload</button>
      </div>
    );
  }
}
